<template>
  <div class="prize-content" v-show="isShow">
    <div
      class="content"
      :style="{
        backgroundImage: `url(${'https://website.xdcdn.net/poster/355916/sausage-match/9Lx32yc9.png'})`,
        transform: `scale(${scale})`
      }"
      @click="hideModal()"
    >
      <!-- <div class="rates">
        <div class="current"></div>
        <div class="expected">
          <span>¥</span>{{ currentCount.toLocaleString() }}
        </div>
      </div> -->
      <div class="rates">
        <div class="sha-current">当前奖金</div>
        <div class="current">当前奖金</div>

        <div class="sha-expected">
          <span>￥</span>{{ currentCount.toLocaleString() }}
        </div>
        <div class="expected">
          <span>￥</span>{{ currentCount.toLocaleString() }}
        </div>
      </div>
      <div class="close"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as api from '@/service/index'
export default {
  inject: ['json_config'],
  data() {
    return {
      isShow: false,
      currentCount: 0,
      isUpdating: false,
      closePrize: false
    }
  },
  computed: {
    ...mapState(['scale']),
    config() {
      return this.json_config()
    }
  },
  created() {
    // this.handlePrize()
    // this.updatePrize()
  },
  methods: {
    showModal() {
      this.isShow = true
    },
    hideModal() {
      this.isShow = false
    },
    // async handlePrize() {
    //   try {
    //     const res = await api.reqPrize()
    //     if (res.status === 200) {
    //       const { expected_count, current_count } = res.data
    //       this.expectedCount = expected_count
    //       this.currentCount = current_count
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    // updatePrize() {
    //   if (!this.isUpdating) {
    //     this.isUpdating = true
    //     if (this.timer) {
    //       clearInterval(this.timer)
    //     }
    //     this.timer = setInterval(() => {
    //       if (this.closePrize) {
    //         return
    //       }
    //       // this.handlePrize()
    //       this.isUpdating = false
    //     }, 60000)
    //   }
    // },
    beforeDestroy() {
      clearInterval(this.timer)
      this.closePrize = true
    }
  }
}
</script>

<style lang="scss" scoped>
.prize-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
  .content {
    position: absolute;
    width: 1286px;
    height: 724px;
    top: 50%;
    left: 50%;
    margin-left: -0.5 * 1286px;
    margin-top: -0.5 * 724px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    .rates {
      width: 100%;
      height: 100%;
      position: relative;
      font-family: NumFont;
      //  background-color: #000;

      .sha-current,
      .current {
        position: absolute;
        top: 40%;
        left: 51%;
        transform: translate(-51%, -40%);
        font-size: 44px;
        letter-spacing: 13.6px;
        font-weight: 700;
      }
      .sha-current {
        text-shadow: 0px 5px 8px #fff9ef;
        color: transparent;
      }
      .current {
        background: linear-gradient(180deg, #957f52 30%, #d0ba8a 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .sha-expected,
      .expected {
        // margin-top: 10px;
        font-size: 88px;
        position: absolute;
        top: 52%;
        left: 50%;
        transform: translate(-50%, -52%);
        letter-spacing: 17.6px;
        span {
          font-size: 48px;
        }
      }
      .sha-expected {
        text-shadow: 0px 0px 8px #fff9ef;
        color: transparent;
      }
      .expected {
        background: linear-gradient(180deg, #957f52 30%, #d0ba8a 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .close {
      // @include sprite_bg('schedule_close');
      background-image: url('https://website.xdcdn.net/poster/355916/sausage-match/AObWjuhB.png');
      width: 40px;
      height: 40px;
      background-repeat: no-repeat;
      background-size: cover;
      position: absolute;
      top: 54px;
      right: 166px;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
    }
  }
}
</style>